export enum OfferOptionType {
  SINGLE = 'SINGLE',
  ALL = 'ALL'
}
